var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-show",class:{'half':_vm.half}},[(!_vm.hideLabel)?_c('b',{staticClass:"s-show-label",class:{must:_vm.item.must},style:({width:_vm.labelWidth})},[_vm._v("\n        "+_vm._s(_vm.item.label)+"：\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"s-show-cont"},[_vm._v("\n        "+_vm._s(_vm.showData())+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb966814","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/s-input/sInputShow.vue
// module id = gnTQ
// module chunks = 104 105 106